import { Button } from "components/common";
import { TheIcon } from "components/TheComponents";
import { adminIconStyle } from "styles/admin";

interface AdminActionCheckboxProps {
  checked: boolean;
  onChange?: () => void;
  size?: number;
}

const AdminActionCheckbox = ({ checked, onChange, size = 16 }: AdminActionCheckboxProps) => {
  return (
    <Button styles={adminIconStyle} onClick={onChange}>
      {checked ? <TheIcon icon={"save"} size={size} /> : <div style={{ width: `${size}px` }} />}
    </Button>
  );
};

export default AdminActionCheckbox;
